/*
 * @Author: xuejian3721
 * @Date: 2025-04-23 14:54:55
 * @LastEditors: xuejian3721
 * @LastEditTime: 2025-04-29 14:56:57
 */
// 设置客户卡片样式
export function setCustomerStyle(obj) {
  return customerMobileStyle(obj)
}

// app端样式
function customerMobileStyle(obj) {
  return `<div class="msg-card-customer" style="min-height: 62px;display: grid;row-gap: 4px;background: #ffffff;">
        <div style="line-height: 18px;font-size: 13px;">
          <span style="color: #a5a5a5;">客户ID：</span>
          <span style="color: #3a3a3a;">${obj.companyId || '-'}</span>
        </div>
        <div style="line-height: 18px;font-size: 13px;">
          <span style="color: #a5a5a5;">客户名称：</span>
          <span style="color: #3a3a3a;">${obj.companyName || '-'}</span>
        </div>
        <div style="line-height: 18px;font-size: 13px;">
          <span style="color: #a5a5a5;">客户地址：</span>
          <span style="color: #3a3a3a;">${obj.companyAddress || '-'}</span>
        </div>
      </div>`
}
